import * as React from 'react';
import * as classnames from 'classnames';

export interface ITabPanel {
    children: React.ReactNode;
    isCurrent: boolean;
    renderAllContent?: boolean;
    tabHeaderId: string;
    tabPanelId: string;
    panelNotTabbable?: boolean;
}

const classNames = classnames('elc-tabs__panel', 'js-elc-tabs__panel');

export const TabPanel = ({
    children,
    isCurrent,
    renderAllContent,
    tabHeaderId,
    tabPanelId,
    panelNotTabbable
}: ITabPanel) => {
    return (
        <div
            aria-labelledby={tabHeaderId}
            className={classNames}
            hidden={!isCurrent}
            id={tabPanelId}
            role={'tabpanel'}
            tabIndex={panelNotTabbable ? undefined : 0}
        >
            {!renderAllContent && isCurrent && <>{children}</>}

            {renderAllContent && <>{children}</>}
        </div>
    );
};
